import Service from "../Service";

const resource = "TrainingTopic/";

export default {
  list(filter, requestID) {
    return Service.post(resource + "list", filter, {
      params: { requestID },
    });
  },
  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID },
    });
  },
};
